import React from 'react';

const BranchHeader = ({
  inputSearch,
  filter,
  count,
  onSearchSubmit,
  onSearchTextChange,
  onBack,
  showForm,
  onFilterChange,
  handleAdd,
  onClearSearch,
  branch
}) => {

  if (showForm) {
    return (
      <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-3 mb-4">
        <h1 className="text-xl font-bold uppercase text-[#293686]">{ branch ? `Edit Branch(${branch.branch_code})` : 'Add Branch' }</h1>
        <div className="flex flex-col md:flex-row gap-2 w-full md:w-auto">
          <button
          onClick={onBack}
          className="bg-primary-light uppercase text-white px-4 py-1.5 rounded hover:bg-blue-600 text-sm"
        >
          {"< Go Back"}
        </button>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-3 mb-4">
      <h1 className="text-xl font-bold uppercase text-[#293686]">Branches ({count})</h1>
      <div className="flex flex-col md:flex-row gap-2 w-full md:w-auto">
        <form onSubmit={onSearchSubmit} className="relative w-full md:w-72">
          <input
            type="text"
            placeholder="Search by code, phone, email, etc."
            value={inputSearch}
            onChange={onSearchTextChange}
            className="border rounded w-full pl-3 pr-10 py-1.5 text-sm"
          />
          {/* Clear (X) button — appears only when there's text */}
          {inputSearch && (
            <button
              type="button"
              onClick={onClearSearch}
              className="absolute right-8 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
              title="Clear"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-4 w-4"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          )}
          <button
            type="button"
            className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700"
            title="Search"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M21 21l-4.35-4.35m0 0A7.5 7.5 0 104.5 4.5a7.5 7.5 0 0012.15 12.15z"
              />
            </svg>
          </button>
        </form>
        {/* Filter dropdown left on mobile */}
        <select
          className="border rounded px-3 py-1 text-sm md:w-auto"
          value={filter}
          onChange={onFilterChange}
        >
          <option>All</option>
          <option>Active</option>
          <option>Inactive</option>
        </select>

        {/* Add button right on mobile */}
        <button
          onClick={handleAdd}
          className="bg-[#E91C24] uppercase text-white px-4 py-1.5 rounded hover:bg-[#E91C24] text-sm md:w-auto"
        >
          + Add User
        </button>
      </div>
    </div>
  );
};

export default BranchHeader;
